import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ViewController, NavParams } from 'ionic-angular';

import { Item  } from '@providers/asset/index';

@Component({
  selector: 'page-report',
  templateUrl: 'page.html'
})
export class ReportPage {

  List: any = [];
  pilihModal=0;
  base_url='';

  constructor(
    public navCtrl: NavController,
    public itemApi: Item,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.pilihModal = navParams.get('pilih');

    this.List = itemApi.listReport();
    this.base_url = itemApi.base_url;
  }

  ionViewDidEnter() {

  }

  doRefresh(refresher) {
    refresher.complete();

  }

  /* getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { };
    this.masterApi.getCondition(params).subscribe((resp:any) => {
      this.List = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  } */

  select(item){
    document.location.href = this.base_url+'/client/uploads/'+item.url+'.xlsx';
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/report/page.ts